var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <div class=\"pack-summary__item  "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"IsIncludedTypeGroup") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":38},"end":{"line":22,"column":87}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isSelected") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":22,"column":88},"end":{"line":22,"column":126}}})) != null ? stack1 : "")
    + "\" data-groupid=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"GroupID") : depth0), depth0))
    + "\" data-is-build-for-me=\""
    + alias3(alias2((depths[1] != null ? lookupProperty(depths[1],"isBuildForMeFlow") : depths[1]), depth0))
    + "\" data-is-selected=\""
    + alias3(((helper = (helper = lookupProperty(helpers,"isSelected") || (depth0 != null ? lookupProperty(depth0,"isSelected") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"isSelected","hash":{},"data":data,"loc":{"start":{"line":22,"column":225},"end":{"line":22,"column":239}}}) : helper)))
    + "\" tabindex=\"0\">\r\n        <div class=\"top\">\r\n          <div class=\"name\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"IsIncludedTypeGroup") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.program(4, data, 0, blockParams, depths),"data":data,"loc":{"start":{"line":25,"column":12},"end":{"line":36,"column":19}}})) != null ? stack1 : "")
    + "            <p class=\"name-text\">"
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"GroupName") : depth0), depth0))
    + "</p>\r\n          </div>\r\n        </div>\r\n\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depths[1] != null ? lookupProperty(depths[1],"isBuildForMeFlow") : depths[1]),{"name":"if","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":42,"column":8},"end":{"line":66,"column":15}}})) != null ? stack1 : "")
    + "\r\n"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depths[1] != null ? lookupProperty(depths[1],"isBuildForMeFlow") : depths[1]),{"name":"unless","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":68,"column":8},"end":{"line":94,"column":19}}})) != null ? stack1 : "")
    + "      </div>\r\n";
},"1":function(container,depth0,helpers,partials,data) {
    return " no-cursor";
},"2":function(container,depth0,helpers,partials,data) {
    return " editing-card";
},"3":function(container,depth0,helpers,partials,data) {
    return "                <img class=\"progress-icon\" src=\"/assets/images/pack-config/progress-star.svg\" alt=\"Progress Star Icon\">\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <div class=\"product-tiles__meter\">\r\n                  <div\r\n                    data-screen=\"desktop\"\r\n                    data-maxquantity=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"MaxQuantity") : depth0), depth0))
    + "\"\r\n                    data-groupid=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"GroupID") : depth0), depth0))
    + "\"\r\n                    class=\"meter label-center meter-pack-summary\"\r\n                  ></div>\r\n                </div>\r\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          <div class=\"bottom\">\r\n            <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"MatchingProducts") : depth0),{"name":"each","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":45,"column":14},"end":{"line":63,"column":23}}})) != null ? stack1 : "")
    + "            </ul>\r\n          </div>\r\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <li>\r\n                  <div class=\"list-item\">\r\n                    <div class=\"flavor-info\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"PackagingName") : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.program(8, data, 0),"data":data,"loc":{"start":{"line":49,"column":22},"end":{"line":53,"column":29}}})) != null ? stack1 : "")
    + "                    </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"UpchargeAmount") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":55,"column":20},"end":{"line":60,"column":27}}})) != null ? stack1 : "")
    + "                  </div>\r\n                </li>\r\n";
},"7":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <p>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"ShortName") : depth0), depth0))
    + ", "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"PackagingName") : depth0), depth0))
    + ", "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"FlavorName") : depth0), depth0))
    + " - <span>QTY: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Quantity") : depth0), depth0))
    + "</p>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <p>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Name") : depth0), depth0))
    + " - <span>QTY: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Quantity") : depth0), depth0))
    + "</p>\r\n";
},"9":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                      <div class=\"upcharge-wrapper\">\r\n                        <img src=\"/assets/images/pack-config/upcharge-icon.svg\" alt=\"Upcharge Icon\">\r\n                        "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"UpchargeDisplay") : depth0), depth0))
    + "\r\n                      </div>\r\n";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"IsIncludedTypeGroup") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":69,"column":10},"end":{"line":93,"column":17}}})) != null ? stack1 : "");
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "            <div class=\"bottom\">\r\n              <ul>\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"MatchingProducts") : depth0),{"name":"each","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":72,"column":16},"end":{"line":90,"column":25}}})) != null ? stack1 : "")
    + "              </ul>\r\n            </div>\r\n";
},"12":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                  <li>\r\n                    <div class=\"list-item\">\r\n                      <div class=\"flavor-info\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"PackagingName") : depth0),{"name":"if","hash":{},"fn":container.program(13, data, 0),"inverse":container.program(14, data, 0),"data":data,"loc":{"start":{"line":76,"column":24},"end":{"line":80,"column":31}}})) != null ? stack1 : "")
    + "                      </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"UpchargeAmount") : depth0),{"name":"if","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":82,"column":22},"end":{"line":87,"column":29}}})) != null ? stack1 : "")
    + "                    </div>\r\n                  </li>\r\n";
},"13":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <p>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"ShortName") : depth0), depth0))
    + ", "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"PackagingName") : depth0), depth0))
    + ", "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"FlavorName") : depth0), depth0))
    + " - <span>QTY: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Quantity") : depth0), depth0))
    + "</p>\r\n";
},"14":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                          <p>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Name") : depth0), depth0))
    + " - <span>QTY: "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"Quantity") : depth0), depth0))
    + "</p>\r\n";
},"15":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                        <div class=\"upcharge-wrapper\">\r\n                          <img src=\"/assets/images/pack-config/upcharge-icon.svg\" alt=\"Upcharge Icon\">\r\n                          "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"UpchargeDisplay") : depth0), depth0))
    + "\r\n                        </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"edit-packsummary-container\">\r\n  <div class=\"edit-packsummary-container__header\">\r\n      <h5>"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"Labels") : depth0)) != null ? lookupProperty(stack1,"PackSummary") : stack1), depth0))
    + "</h5>\r\n      <button type=\"button\" class=\"start-over-btn\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"Labels") : depth0)) != null ? lookupProperty(stack1,"StartOver") : stack1), depth0))
    + "</button>\r\n  </div>\r\n\r\n  <div class=\"edit-packsummary-container__mobile-dropdown\">\r\n    <button type=\"button\" class=\"start-over-btn\">"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"Labels") : depth0)) != null ? lookupProperty(stack1,"StartOver") : stack1), depth0))
    + "</button>\r\n    <span>"
    + alias2(alias1(((stack1 = (depth0 != null ? lookupProperty(depth0,"Labels") : depth0)) != null ? lookupProperty(stack1,"PackSummary") : stack1), depth0))
    + "</span>\r\n    <button type=\"button\" class=\"edit-packsummary-container__dropdown-icon js-summary-dropdown\">\r\n      <img\r\n        height=\"10px\"\r\n        width=\"16px\"\r\n        src=\"/assets/images/icons/icon-arrow-down-gray.png\"\r\n        alt=\"drawer-icon\"\r\n      />\r\n    </button>\r\n  </div>\r\n\r\n  <div class=\"pack-summary\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"packData") : depth0),{"name":"each","hash":{},"fn":container.program(0, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":21,"column":4},"end":{"line":96,"column":13}}})) != null ? stack1 : "")
    + "  </div>\r\n</div>\r\n";
},"useData":true,"useDepths":true});